/* eslint-disable react-hooks/exhaustive-deps */
import { useCallback, useEffect, useRef, useState } from "react";
import { useParams } from "react-router";
import { downloadToFile, imageUrlToBase64 } from "../../helpers";
import Page404 from "../page_404";
import axios from "axios";
import { Container, Card, Col, Image, Row, Button } from "react-bootstrap";
import { FaEnvelope, FaLinkedin, FaWhatsapp } from "react-icons/fa";
import QrCode from "../../components/qrcode";

interface HelloData {
  position?: string;
  full_name?: string;
  email?: string;
  phone_number?: string;
  linkedin_username?: string;
  picture_url?: string;
}

export default function Hello() {
  const refImage = useRef<HTMLImageElement>(null);
  const { name } = useParams();

  const [loading, setLoading] = useState<boolean>(true);
  const [helloData, setHelloData] = useState<HelloData | null>(null);
  const [vcard, setVcard] = useState<string | null>(null);
  const [shortVcard, setShortVcard] = useState<string | null>(null);

  useEffect(() => {
    setLoading(true);
    if (!name) {
      setHelloData(null);
      setLoading(false);
      return;
    }
    axios.get(`/hello.json`).then(({ data }) => {
      if (!data[name]) {
        setHelloData(null);
        setLoading(false);
        return;
      }
      setHelloData(data[name] ?? null);
      setLoading(false);
    });
  }, [name]);
  useEffect(() => {
    const generateVcard = async () => {
      if (helloData) {
        const data = helloData;

        let vcard = `BEGIN:VCARD
VERSION:4.0
FN:${data.full_name}
EMAIL;work=work:${data.email}
ORG:Pohon Dana Indonesia
URL;website=website:https://www.pohondana.id
`;

        if (data.position) {
          vcard = vcard + `\nTITLE:${data.position}`;
        }
        if (data.phone_number) {
          vcard = vcard + `\nTEL:${data.phone_number}`;
        }
        const splitName = (data?.full_name || "").split(" ");
        const givenName = splitName[0];
        const lastName = splitName.length > 1 ? splitName[1] : "";

        vcard = vcard + `\nN:${lastName};${givenName};;;;`;
        if (data.linkedin_username) {
          vcard =
            vcard +
            `\nURL;Linkedin=Linkedin:https://www.linkedin.com/in/${helloData?.linkedin_username}`;
        }
        let shortVcard = vcard;

        vcard =
          vcard +
          `\nADR;TYPE=work;LABEL="Mayapada Tower 1, 9th floor, Jln. Jend. Sudirman Kav. 28\nKel. Karet, Kec. Setiabudi\nJakarta Selatan 12920\nIndonesia":;;Mayapada Tower 1, 9th floor, Jln. Jend. Sudirman Kav. 28;Karet;Setiabudi;Jakarta Selatan;12920;Indonesia`;
        if (data.picture_url && refImage) {
          let imgData: any = await imageUrlToBase64(data.picture_url);
          const base64 = imgData.base64.split(";")[1].replace("base64,", "");

          vcard =
            vcard +
            `\nPHOTO;MEDIATYPE=${imgData.type};ENCODING=BASE64:${base64}`;
        }

        vcard = vcard + `\nEND:VCARD`;
        shortVcard = shortVcard + `\nEND:VCARD`;
        setVcard(vcard);
        setShortVcard(shortVcard);
      }
    };

    generateVcard();
  }, [helloData]);

  const makeVCard = useCallback(
    async (e: any) => {
      e.stopPropagation();
      e.preventDefault();
      if (vcard && helloData) {
        downloadToFile(vcard, helloData?.full_name + ".vcf", "text/vcard");
      }
    },
    [helloData, name, vcard]
  );

  if (!helloData && !loading) {
    return <Page404 />;
  }

  return (
    <div className="main-container" id="hello-page">
      <Container className="my-5">
        <Row>
          <Col xs={12} sm={12} md={11} lg={11} xl={8} className="mx-auto">
            <Card>
              <Card.Body>
                <Row className="justify-content-center">
                  {helloData?.picture_url && (
                    <Col xs="auto" sm="auto" md="auto" lg="auto">
                      <Image
                        ref={refImage}
                        alt={helloData?.full_name}
                        src={helloData?.picture_url}
                        style={{
                          maxHeight: 250,
                          maxWidth: 120,
                          borderRadius: 24,
                        }}
                      />
                    </Col>
                  )}
                  <Col>
                    <div className="text-size-sub-headline fw-extra-bold">
                      {helloData?.full_name}
                    </div>
                    <div className="text-size-body-head-2 mb-2">
                      {helloData?.position}
                    </div>
                    <div className="d-flex align-items-center gap-2">
                      <FaEnvelope className="text-primary-main" />
                      <a
                        href={`mailto:${helloData?.email}`}
                        rel="noreferrer"
                        target="_blank"
                      >
                        {helloData?.email}
                      </a>
                    </div>
                    <div className="d-flex align-items-center gap-2">
                      <FaWhatsapp className="text-primary-main" />
                      <a
                        href={`https://wa.me/${helloData?.phone_number?.replace(
                          "+",
                          ""
                        )}`}
                        rel="noreferrer"
                        target="_blank"
                      >
                        {helloData?.phone_number}
                      </a>
                    </div>
                    {helloData?.linkedin_username && (
                      <div className="d-flex align-items-center gap-2">
                        <FaLinkedin className="text-primary-main" />
                        <a
                          href={`https://www.linkedin.com/in/${helloData?.linkedin_username}`}
                          rel="noreferrer"
                          target="_blank"
                        >
                          {helloData?.linkedin_username}
                        </a>
                      </div>
                    )}
                  </Col>
                  {shortVcard && (
                    <Col
                      xs={12}
                      sm={12}
                      md="auto"
                      lg="auto"
                      className="text-center mt-4 mt-md-0"
                    >
                      <QrCode size={140} url={shortVcard} />
                      <div className="text-size-label-2 text-secondary">
                        scan to save vCard
                      </div>
                    </Col>
                  )}
                </Row>
                <div className="text-center text-md-end text-size-label text-secondary mt-5">
                  <div className="mb-2">
                    <Image
                      src="/images/logo-black.png"
                      alt="Pohon Dana"
                      style={{ width: 160 }}
                    />
                  </div>
                  <div>PT Pohon Dana Indonesia</div>
                  <div>
                    Mayapada Tower 1, 8th floor, Jln. Jend. Sudirman Kav. 28
                  </div>
                  <div>Kel. Karet, Kec. Setiabudi, Jakarta Selatan</div>
                  <div>12920, Indonesia</div>
                </div>
              </Card.Body>
            </Card>
          </Col>
        </Row>
        <div className="text-center mt-4">
          <Button variant="primary" onClick={makeVCard}>
            Download Contact (vCard)
          </Button>
        </div>
      </Container>
    </div>
  );
}
